module.exports = __webpack_public_path__ + "static/RedBankTitle-7de6eb1f2c51dac564da182af0068c1c.png";